import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from '@mui/material';

export function RevenueTransactions({ transactions }) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Date</TableCell>
          <TableCell>Montant</TableCell>
          <TableCell>Moyen</TableCell>
          <TableCell>Statut</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {transactions.map((tx) => (
          <TableRow key={tx.id}>
            <TableCell>{tx.date}</TableCell>
            <TableCell>{tx.amount} FCFA</TableCell>
            <TableCell>{tx.method}</TableCell>
            <TableCell>
              <Chip
                label={tx.status}
                color={tx.status === 'Succès' ? 'success' : 'warning'}
                size="small"
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
